import React, { Component } from 'react';
import AsyncSelect from 'react-select/async';
import Axios from 'axios';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { InputSwitch } from 'primereact/inputswitch';
import { InputNumber } from 'primereact/inputnumber';
import { estados } from '../../util/estados';
import { asyncSelectCustomStyles } from '../../util/styles';
import tipos from '../MapaRevendaLocacao/tipos';

const TIPO_NEGOCIO_OPTIONS = [
    { value: 'Venda', label: 'Revenda' },
    { value: 'Aluguel', label: 'Locação' },
];

const DORMITORIOS = [0, 1, 2, 3, 4];
const VAGAS = [0, 1, 2, 3, 4];

/**
 * Painel de filtros do mapa de Revenda e Locação (Mapbox). Componente controlado:
 * o componente pai (MapaRevendaLocacaoMapbox) detém todo o estado dos filtros e
 * recebe as mudanças via onChange(field, value). Espelha o FormFilters do mapa
 * Google (MapaRevendaLocacao/FormFilters.jsx), migrando os inputs de moeda para
 * PrimeReact InputNumber e mantendo a busca de cidade assíncrona (react-select).
 */
class FormFiltersRevenda extends Component {
    // Busca de cidades por estado (≥2 caracteres), como no mapa Google.
    searchCidade = async (inputQuery) => {
        const uf = this.props.filters.estadosSelecionados || null;
        if (!inputQuery || inputQuery.length < 2) return [];

        try {
            const response = await Axios.get(`/cidades/json-options-by-state/${uf}/${inputQuery}`);
            return response.data || [];
        } catch (e) {
            console.error('[FormFiltersRevenda] erro na busca de cidades:', e);
            return [];
        }
    };

    render() {
        const { filters, projetoOptions, hasAreas, onChange, showAlertCity } = this.props;

        return (
            <div className="mrl-mapbox-filtros">
                <div className="form-group">
                    <label>Carregar Projeto</label>
                    <Dropdown
                        options={projetoOptions}
                        value={filters.projeto || null}
                        onChange={(e) => this.props.onProjetoChange(e.value)}
                        style={{ width: '100%' }}
                        placeholder="Selecione"
                    />
                </div>

                <div className="form-group">
                    <label>Tipo Negócio</label>
                    <Dropdown
                        options={TIPO_NEGOCIO_OPTIONS}
                        value={filters.tipo_negocio}
                        onChange={(e) => onChange('tipo_negocio', e.value)}
                        style={{ width: '100%' }}
                        placeholder="Selecione"
                    />
                </div>

                <div className="form-group">
                    <label>Tipo Empreendimento</label>
                    <MultiSelect
                        resetFilterOnHide
                        value={filters.tipo_empreendimento}
                        options={tipos.select_options}
                        onChange={(e) => onChange('tipo_empreendimento', e.value)}
                        style={{ width: '100%' }}
                        placeholder="Selecione"
                        filter
                        display="chip"
                        showClear
                        maxSelectedLabels={3}
                        selectedItemsLabel="{0} itens selecionados"
                        emptyFilterMessage="Nenhum resultado encontrado"
                    />
                </div>

                <div className="form-group">
                    <label>Estado</label>
                    <Dropdown
                        options={estados}
                        value={filters.estadosSelecionados}
                        onChange={(e) => this.props.onEstadoChange(e.value)}
                        style={{ width: '100%' }}
                        placeholder="Selecione"
                    />
                </div>

                <div className="form-group">
                    <label>Cidade</label>
                    <AsyncSelect
                        styles={asyncSelectCustomStyles}
                        placeholder="Selecione"
                        isMulti={false}
                        value={filters.cidade[0] || null}
                        loadOptions={this.searchCidade}
                        onChange={(option) => this.props.onCidadeChange(option)}
                        loadingMessage={() => 'Carregando...'}
                        noOptionsMessage={() => 'Digite para buscar...'}
                    />
                </div>

                <div className="form-group">
                    <label>Bairros</label>
                    <MultiSelect
                        resetFilterOnHide
                        options={filters.bairrosOptions}
                        value={filters.bairros}
                        onChange={(e) => onChange('bairros', e.value)}
                        style={{ width: '100%' }}
                        placeholder="Selecione"
                        display="chip"
                        showClear
                        maxSelectedLabels={3}
                        selectedItemsLabel="{0} itens selecionados"
                        filter
                        emptyFilterMessage="Nenhum resultado encontrado"
                    />
                </div>

                <div className="form-group row">
                    <div className="col-6">
                        <label>Área Mínima</label>
                        <InputNumber
                            value={filters.area_maior_que}
                            onValueChange={(e) => onChange('area_maior_que', e.value)}
                            inputStyle={{ width: '100%' }}
                            suffix=" m²"
                            min={0}
                        />
                    </div>
                    <div className="col-6">
                        <label>Área Máxima</label>
                        <InputNumber
                            value={filters.area_menor_que}
                            onValueChange={(e) => onChange('area_menor_que', e.value)}
                            inputStyle={{ width: '100%' }}
                            suffix=" m²"
                            min={0}
                        />
                    </div>
                </div>

                <div className="form-group row">
                    <div className="col-6">
                        <label>Preço Mínimo</label>
                        <InputNumber
                            value={filters.valor_maior_que}
                            onValueChange={(e) => onChange('valor_maior_que', e.value)}
                            mode="currency"
                            currency="BRL"
                            locale="pt-BR"
                            inputStyle={{ width: '100%' }}
                            inputClassName={showAlertCity ? 'p-invalid' : ''}
                            min={0}
                        />
                    </div>
                    <div className="col-6">
                        <label>Preço Máximo</label>
                        <InputNumber
                            value={filters.valor_menor_que}
                            onValueChange={(e) => onChange('valor_menor_que', e.value)}
                            mode="currency"
                            currency="BRL"
                            locale="pt-BR"
                            inputStyle={{ width: '100%' }}
                            inputClassName={showAlertCity ? 'p-invalid' : ''}
                            min={0}
                        />
                    </div>
                </div>

                <div className="form-group row">
                    <div className="col-6">
                        <label>Preço R$/m² Mínimo</label>
                        <InputNumber
                            value={filters.valor_metro_maior_que}
                            onValueChange={(e) => onChange('valor_metro_maior_que', e.value)}
                            mode="currency"
                            currency="BRL"
                            locale="pt-BR"
                            inputStyle={{ width: '100%' }}
                            min={0}
                        />
                    </div>
                    <div className="col-6">
                        <label>Preço R$/m² Máximo</label>
                        <InputNumber
                            value={filters.valor_metro_menor_que}
                            onValueChange={(e) => onChange('valor_metro_menor_que', e.value)}
                            mode="currency"
                            currency="BRL"
                            locale="pt-BR"
                            inputStyle={{ width: '100%' }}
                            min={0}
                        />
                    </div>
                </div>

                <div className="form-group margin-bottom-0">
                    <label className="d-block">Quartos</label>
                    {DORMITORIOS.map((q) => (
                        <div className="form-check checkbox-inline pr-1" key={`quarto-${q}`}>
                            <div className="d-flex align-items-center">
                                <InputSwitch
                                    inputId={`check_quarto_${q}`}
                                    checked={filters.quartos.includes(q)}
                                    onChange={() => this.props.onToggleQuarto(q)}
                                />
                                <label htmlFor={`check_quarto_${q}`} className="pl-1 mb-0 ms-2">
                                    {q === 4 ? '4+' : q}
                                </label>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="form-group">
                    <label className="d-block">Vagas</label>
                    {VAGAS.map((v) => (
                        <div className="form-check checkbox-inline pr-1" key={`vaga-${v}`}>
                            <div className="d-flex align-items-center">
                                <InputSwitch
                                    inputId={`check_vaga_${v}`}
                                    checked={filters.vagas.includes(v)}
                                    onChange={() => this.props.onToggleVaga(v)}
                                />
                                <label htmlFor={`check_vaga_${v}`} className="pl-1 mb-0 ms-2">
                                    {v === 4 ? '4+' : v}
                                </label>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="row mrl-mapbox-filtros-actions">
                    <div className="col-6">
                        <button className="btn btn-block background-brain" onClick={this.props.onSubmit}>
                            {hasAreas ? 'ATUALIZAR' : 'BUSCAR'}
                        </button>
                    </div>
                    <div className="col-6">
                        <button className="btn btn-block btn-default default-gray" onClick={this.props.onClear}>
                            LIMPAR
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default FormFiltersRevenda;
